import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Slider } from "@material-ui/core";

class BackgroundPositionEditor extends Component {
  containerRef = React.createRef();

  constructor(props) {
    super(props);
    const { customization } = props.config;
    this.state = {
      dragging: null,
      position_x: customization.background_position_x,
      position_y: customization.background_position_y,
      width: customization.background_width,
      height: customization.background_height
    };
  }

  componentDidUpdate(prevProps) {
    const { dragging } = this.state;
    const prev = prevProps.config.customization;
    const curr = this.props.config.customization;

    if (
      !dragging &&
      (prev.background_position_x !== curr.background_position_x ||
        prev.background_position_y !== curr.background_position_y ||
        prev.background_width !== curr.background_width ||
        prev.background_height !== curr.background_height)
    ) {
      this.setState({
        position_x: curr.background_position_x,
        position_y: curr.background_position_y,
        width: curr.background_width,
        height: curr.background_height
      });
    }
  }

  componentWillUnmount() {
    this.removeListeners();
  }

  removeListeners = () => {
    document.removeEventListener("mousemove", this.handleMouseMove);
    document.removeEventListener("mouseup", this.handleMouseUp);
  };

  clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  commit = () => {
    const { config, updateConfig } = this.props;
    const { position_x, position_y, width, height } = this.state;
    config.customization.background_position_x = position_x;
    config.customization.background_position_y = position_y;
    config.customization.background_width = width;
    config.customization.background_height = height;
    updateConfig(config);
  };

  startDrag = (type) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { position_x, position_y, width, height } = this.state;

    this.dragOrigin = {
      clientX: e.clientX,
      clientY: e.clientY,
      position_x,
      position_y,
      width,
      height
    };

    this.setState({ dragging: type });
    document.addEventListener("mousemove", this.handleMouseMove);
    document.addEventListener("mouseup", this.handleMouseUp);
  };

  handleMouseMove = (e) => {
    const { dragging } = this.state;
    if (!dragging || !this.containerRef.current) {
      return;
    }

    const rect = this.containerRef.current.getBoundingClientRect();
    const deltaXPercent = ((e.clientX - this.dragOrigin.clientX) / rect.width) * 100;
    const deltaYPercent = ((e.clientY - this.dragOrigin.clientY) / rect.height) * 100;

    if (dragging === "move") {
      this.setState({
        position_x: this.clamp(this.dragOrigin.position_x + deltaXPercent, 0, 100),
        position_y: this.clamp(this.dragOrigin.position_y + deltaYPercent, 0, 100)
      });
    } else {
      this.setState({
        width: this.clamp(this.dragOrigin.width + deltaXPercent, 5, 100),
        height: this.clamp(this.dragOrigin.height + deltaYPercent, 5, 100)
      });
    }
  };

  handleMouseUp = () => {
    this.removeListeners();
    this.setState({ dragging: null }, this.commit);
  };

  updateSize = (e, value) => {
    this.setState({ width: value, height: value });
  };

  updatePositionX = (e, value) => {
    this.setState({ position_x: value });
  };

  updatePositionY = (e, value) => {
    this.setState({ position_y: value });
  };

  render() {
    const { t, config } = this.props;
    const { width, height, position_x, position_y } = this.state;
    const imgSrc = config.background_icon || `${process.env.PUBLIC_URL}/background_widget.png`;

    return (
      <div className={"elements__background_editor"}>
        <div className={"elements__background_editor_page"} ref={this.containerRef}>
          <img
            src={imgSrc}
            alt={"centribal_background"}
            draggable={false}
            onMouseDown={this.startDrag("move")}
            className={"elements__background_editor_img"}
            style={{
              width: `${width}%`,
              height: `${height}%`,
              left: `${position_x}%`,
              top: `${position_y}%`
            }}
          />
          <span
            onMouseDown={this.startDrag("resize")}
            className={"elements__background_editor_handle"}
            style={{
              left: `${position_x + width / 2}%`,
              top: `${position_y + height / 2}%`
            }}
          />
        </div>
        <div className={"elements__background_editor_sliders"}>
          <div className={"elements__background_editor_slider"}>
            <span>
              {t("card.content.project.web_interface.customization.background.size_label")} ({Math.round(width)}%)
            </span>
            <Slider
              value={width}
              min={5}
              max={100}
              onChange={this.updateSize}
              onChangeCommitted={this.commit}
            />
          </div>
          <div className={"elements__background_editor_slider"}>
            <span>
              {t("card.content.project.web_interface.customization.background.position_x_label")} ({Math.round(position_x)}%)
            </span>
            <Slider
              value={position_x}
              min={0}
              max={100}
              onChange={this.updatePositionX}
              onChangeCommitted={this.commit}
            />
          </div>
          <div className={"elements__background_editor_slider"}>
            <span>
              {t("card.content.project.web_interface.customization.background.position_y_label")} ({Math.round(position_y)}%)
            </span>
            <Slider
              value={position_y}
              min={0}
              max={100}
              onChange={this.updatePositionY}
              onChangeCommitted={this.commit}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation("common")(BackgroundPositionEditor);
